import { MultiselectCommand } from '../../core/model/command';

export const rentApplicationCommand = {
  export: 'export',
};

export class RentApplicationMultiselectCommand extends MultiselectCommand {
  constructor(id: string, items: any[], itemsSource: any[], contextId?: string) {
    super(id, items, itemsSource, contextId);
  }
}
